import React, { useEffect, useState } from "react";
import { Form, Input, Button, Select, Row, Col, Upload, message, Typography } from "antd";
import axios from "axios";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Title } = Typography;

const InspectionForm = ({ inspectionData, setInspectionData, closeModal, setSubmitted }) => {
  const [form] = Form.useForm();
  const [vehicles, setVehicles] = useState([]);

  useEffect(() => {
    fetchVehicles();
  }, []);

  useEffect(() => {
    if (inspectionData) {
      form.setFieldsValue(inspectionData);
    }
  }, [inspectionData, form]);

  const fetchVehicles = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/vehicles");
      setVehicles(response.data);
    } catch (error) {
      message.error("Unable to load vehicles");
    }
  };

  const onFinish = async (values) => {
    const submitData = new FormData();

    Object.keys(values).forEach((key) => {
      if (key === "photos") {
        values[key]?.fileList.forEach((file, index) => {
          const fieldName = ["topPhoto", "frontPhoto", "backPhoto", "leftPhoto", "rightPhoto"][index];
          if (fieldName) {
            submitData.append(fieldName, file.originFileObj);
          }
        });
      } else {
        submitData.append(key, values[key]);
      }
    });

    try {
      let response;
      if (inspectionData?.id) {
        response = await axios.put(`http://93.127.203.113:5005/inspections/${inspectionData.id}`, submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await axios.post("http://93.127.203.113:5005/inspections", submitData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      message.success("Inspection saved successfully");
      setInspectionData(null);
      closeModal();
      setSubmitted(true);
    } catch (error) {
      message.error("Failed to save inspection");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title
        level={4}
        style={{ color: "#0c8c49", marginBottom: "20px", textAlign: "center" }}
      >
        {inspectionData?.id ? "Edit Inspection" : "Add Inspection"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Vehicle"
              name="vehicleId"
              rules={[{ required: true, message: "Please select a vehicle" }]}
            >
              <Select placeholder="Select a vehicle">
                {vehicles.map((vehicle) => (
                  <Option key={vehicle.id} value={vehicle.id}>
                    {`${vehicle.plateNumber} (${vehicle.model})`}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Fuel Status"
              name="fuelStatus"
              rules={[{ required: true, message: "Please select the fuel status" }]}
            >
              <Select placeholder="Select fuel status">
                <Option value="Full">Full</Option>
                <Option value="Empty">Empty</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label="Status"
              name="status"
              rules={[{ required: true, message: "Please select the status" }]}
            >
              <Select placeholder="Select status">
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Remarks" name="remarks">
              <Input.TextArea rows={3} placeholder="Add any remarks (optional)" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              label="Photos (Top, Front, Back, Left, Right)"
              name="photos"
            >
              <Upload
                multiple={true}
                listType="picture"
                beforeUpload={() => false}
              >
                <Button icon={<UploadOutlined />}>Upload Photos</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{
              backgroundColor: "#0c8c49",
              borderColor: "#0c8c49",
              marginRight: "10px",
            }}
          >
            Save
          </Button>
          <Button
            htmlType="button"
            onClick={() => {
              form.resetFields();
            }}
          >
            Reset
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default InspectionForm;
